import React, { Component } from 'react';
import './Ingredients.css';
import styled from 'styled-components';

export default class Ingredients extends Component {
  constructor(props) {
    super(props);
    this.state = { ingredients: this.props.ingredients, input: '' };
    this.onChange = this.onChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.editStyleDisplay = this.editStyleDisplay.bind(this);
  }

  onChange(e) {
    const value = e.target.value;
    this.setState({ input: value });
  }

  handleDelete(id) {
    if (this.props.edit) {
      let ingredients = [];
      this.state.ingredients.forEach(ingredient => {
        if (ingredient.id !== id) ingredients.push(ingredient);
      });
      this.props.onClick(this.props.id, 'ingredients', ingredients);
      this.setState({ ingredients: ingredients });
    }
  }

  handleClick(e) {
    e.preventDefault();
    let input = this.state.input.split(' ');
    let amount = input.length > 1 ? input[0] : '';
    let ingredient = input.reduce((a, b, i) => (i > 1 ? a + ' ' + b : b));
    const ingredientsState = this.state.ingredients;
    let ingredients = ingredientsState ? ingredientsState : [];

    ingredients.push({
      amount,
      ingredient
    });

    ingredients = ingredients.map((ing, ind) => ({
      amount: ing.amount,
      ingredient: ing.ingredient,
      id: ind
    }));

    this.props.onClick(this.props.id, 'ingredients', ingredients);
    this.setState({ ingredients: ingredients });
    document
      .getElementById('food-page-ingredients-form' + this.props.id)
      .reset();
  }

  editStyleDisplay = () => {
    let display = this.props.edit ? 'flex' : 'none';
    return { display };
  };

  divHover = styled.div`
    :hover {
      cursor: ${() => (this.props.edit ? 'pointer' : 'auto')};
    }
    :hover {
      text-decoration: ${() => (this.props.edit ? 'line-through' : 'none')};
    }
  `;

  render() {
    const ingredients = this.props.ingredients ? this.props.ingredients : [];
    return (
      <div className="ingredients">
        <h3>Zutaten</h3>
        <ul>
          {ingredients.map(ingredient => {
            return (
              <li key={ingredient.id + 10}>
                <div key={ingredient.id} className="amount">
                  {ingredient.amount}
                </div>
                <this.divHover
                  key={ingredient.id + 1}
                  className="ingredient"
                  onClick={this.handleDelete.bind(this, ingredient.id)}
                >
                  {ingredient.ingredient}
                </this.divHover>
              </li>
            );
          })}
        </ul>
        <form
          onSubmit={this.handleClick}
          style={this.editStyleDisplay()}
          id={'food-page-ingredients-form' + this.props.id}
        >
          <input
            type="text"
            placeholder="Zutat hinzufügen.."
            onChange={this.onChange}
          />
          <div className="btn" onClick={this.handleClick}>
            +
          </div>
        </form>
      </div>
    );
  }
}
